export const CDN_URL = 'https://cdn.migros.ch';
export const MgbTheme = {
  name: 'MGB Theme',
  themeId: 'mgb',
  colors: {
    brand: {
      primary: {
        10: '#FFFFFF',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '#F5F5F5',
        100: '#FF6600'
      },
      secondary: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#DE450A'
      },
      accent: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#FF6600'
      },
      text: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#333333'
      },
      textInverted: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#FFFFFF'
      },
      negative: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '#FEE1DC',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#EE0000'
      },
      positive: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#468C00'
      },
      highlight: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#00AECF'
      },
      altHighlight: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#17A1E6'
      },
      background: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#FFFFFF'
      },
      backgroundHighlight: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#EEF8FE'
      },
      grayout: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#BBBBBB'
      },
      alternative: {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '#FF6600'
      }
    },
    tints: {
      gray: {
        5: '#FAFAFA',
        10: '#F1EFEE',
        25: '#E7E5E3',
        30: '#E0E0E0',
        40: '#D9D9D9',
        45: '#cfcac7',
        50: '#BBBBBB',
        60: '#949494',
        75: '#888888',
        80: '#808080',
        90: '#767676',
        100: '#666666'
      },
      white: {
        100: '#FFFFFF'
      },
      black: {
        85: '#333333',
        90: '#111111'
      }
    }
  },
  backgrounds: {
    tile: `url(${CDN_URL}/ch.migros.msrc/img/stores/20200317/market-details/tiles/wood.jpg) repeat`
  },
  shadows: {
    base: '0px 6px 16px 0px rgba(0, 0, 0, 0.16)'
  },
  fonts: {
    families: {
      text: '"Helvetica Now Text", "Helvetica Now Text Regular", "Helvetica", arial, sans-serif',
      condensed: '"Helvetica Now Text", "Helvetica Now Text Bold", "Helvetica", arial, sans-serif',
      notes: '"MarketWeb", "Helvetica", arial, sans-serif',
      heading: '"Helvetica Now Text", "Helvetica Now Text XBold", "Helvetica", arial, sans-serif',
      subHeading: '"Helvetica Now Text", "Helvetica Now Text XBold", "Helvetica", arial, sans-serif',
      display: '"Helvetica Now Text", "Helvetica Now Text XBold", "Helvetica", arial, sans-serif',
      articleText: '"Helvetica Now Text", "Helvetica Now Text Regular", "Helvetica", arial, sans-serif',
      articleHeading: '"Helvetica Now Text", "Helvetica Now Text XBold", "Helvetica", arial, sans-serif',
      articlePrice: '"Helvetica Now Display", "Helvetica", arial, sans-serif'
    },
    weights: {
      thin: 100,
      light: 300,
      regular: 400,
      medium: 600,
      semiBold: 700,
      bold: 800,
      bolder: 900
    },
    sizes: {
      text: {
        tiny: '12px',
        xtiny: '13px',
        xsmall: '14px',
        modest: '15px',
        small: '16px',
        medium: '18px',
        large: '20px',
        xlarge: '24px',
        huge: '28px'
      },
      heading: {
        tiny: '18px',
        xtiny: '19px',
        xsmall: '20px',
        modest: '22px',
        small: '24px',
        medium: '28px',
        large: '32px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  },
  spacings: {
    tiny: '2px',
    xtiny: '4px',
    xsmall: '5px',
    small: '10px',
    medium: '16px',
    large: '20px',
    xlarge: '30px',
    xxlarge: '32px',
    huge: '40px'
  },
  spacingsViewPort: {
    medium: '24px',
    large: '32px'
  },
  spacingsItem: {
    small: '8px',
    medium: '8px'
  },
  lineHeight: {
    none: '1',
    tight: '1.25',
    normal: '1.5'
  },
  borderRadiuses: {
    xsmall: '2px',
    small: '4px',
    medium: '10px',
    large: '20px'
  },
  borderItemRadiuses: {
    small: '8px'
  }
};